import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ArticleComponent } from './components/article/article.component';
import { MessageComponent } from './components/message/message.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { AuthGuardService } from './services/auth-guard.service';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'registration',
    loadChildren: () => import('./pages/registration/registration.module').then(m => m.RegistrationPageModule)
  },
  {
    path: 'students',
    loadChildren: () => import('./pages/students/students.module').then(m => m.StudentsPageModule)
  },
  {
    path: 'teachers',
    loadChildren: () => import('./pages/teachers/teachers.module').then(m => m.TeachersPageModule)
  },
  {
    path: 'schools',
    loadChildren: () => import('./pages/schools/schools.module').then(m => m.SchoolsPageModule)
  },
  {
    path: 'corporates',
    loadChildren: () => import('./pages/corporates/corporates.module').then(m => m.CorporatesPageModule)
  },
  {
    path: 'businesses',
    loadChildren: () => import('./pages/businesses/businesses.module').then(m => m.BusinessesPageModule)
  },
  {
    path: 'article/:id',
    component: ArticleComponent,
    canActivate: [AuthGuardService],

  },
  {
    path: 'message/:id',
    component: MessageComponent,
    canActivate: [AuthGuardService],

  },
  {
    path: 'profile/:id',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'search',
    loadChildren: () => import('./pages/search/search.module').then(m => m.SearchPageModule),
    canActivate: [AuthGuardService],
  },

  {
    path: 'tabs',
    component: SideBarComponent,
    children: [{
      path: '',
      children: [
        {
          path: 'home',
          loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
          canActivate: [AuthGuardService],
        },
        {
          path: 'groups',
          loadChildren: () => import('./pages/groups/groups.module').then(m => m.GroupsPageModule),
          canActivate: [AuthGuardService],

        },
        {
          path: 'squares',
          loadChildren: () => import('./pages/squares/squares.module').then(m => m.SquaresPageModule),
          canActivate: [AuthGuardService],

        },
        {
          path: 'connections',
          loadChildren: () => import('./pages/connections/connections.module').then(m => m.ConnectionsPageModule),
          canActivate: [AuthGuardService],
        },
        {
          path: 'profile',
          loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
          canActivate: [AuthGuardService],

        },
        {
          path: '',
          redirectTo: 'home',
          pathMatch: 'full'
        }
      ]
    },
    {
      path: '',
      redirectTo: 'tabs/home',
      pathMatch: 'full'
    }
    ]
  },
  {
    path: 'group/:id',
    loadChildren: () => import('./pages/group/group.module').then(m => m.GroupPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'square/:id',
    loadChildren: () => import('./pages/square/square.module').then(m => m.SquarePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'ledger',
    loadChildren: () => import('./pages/ledger/ledger.module').then(m => m.LedgerPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'shop',
    loadChildren: () => import('./pages/shop/shop.module').then(m => m.ShopPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'library',
    loadChildren: () => import('./pages/library/library.module').then(m => m.LibraryPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule),
    canActivate: [AuthGuardService],

  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('./pages/terms-and-conditions/terms-and-conditions.module').then( m => m.TermsAndConditionsPageModule)
  },
  {
    path: 'about-us',
    loadChildren: () => import('./pages/about-us/about-us.module').then( m => m.AboutUsPageModule)
  },
  {
    path: 'payment-success/:amount',
    loadChildren: () => import('./pages/payment-success/payment-success.module').then( m => m.PaymentSuccessPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }


export class PaymentSuccess100Module {

}

